import { Box, Typography } from '@mui/material';
import calender_icon from 'assets/img/ECommerce/calender_icon.png';
import whatsapp from 'assets/img/ECommerce/whatsapp_icon.png';
import AnimatedButton from 'components/common/AnimatedButton';
import React, { JSX } from 'react';
import { Link } from 'react-router-dom';
import { paths } from 'routes/routes/paths';

export default function FloatingSection(): JSX.Element {
  return (
    <Box
      sx={{
        zIndex: 99,
        position: 'fixed',
        bottom: 0,
        p: 2,
        py: 1,
        pt: 3,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        background:
          'linear-gradient(to top,rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%)',
        backdropFilter: 'blur(2px) saturate(180%)',
        WebkitBackdropFilter: 'blur(2px) saturate(180%)',
      }}
    >
      <Link to={paths.public.schedule}>
        <AnimatedButton
          size="small"
          label={
            <Typography variant="caption" fontSize={13} className="font-helvetica-light">
              Book A FREE Strategy Meet
            </Typography>
          }
          sx={{ zIndex: 9, px: 1.5, height: '39px', display: 'flex', alignItems: 'center', gap: 1 }}
          iconsPosition="start"
          icon={
            <Box
              component="img"
              src={calender_icon}
              alt="hero"
              sx={{
                width: '15px',
                height: '15px',
              }}
            />
          }
        />
      </Link>

      <a
        href="https://wa.me/919562110055"
        target="_blank"
        rel="noopener noreferrer"
        style={{ display: 'inline-flex' }}
        title="Chat with us on WhatsApp"
      >
        <Box
          component="img"
          src={whatsapp}
          alt="WhatsApp"
          sx={{
            width: '54px',
            height: '54px',
          }}
        />
      </a>
    </Box>
  );
}
